module.exports = __webpack_public_path__ + "static/media/centrica-logo-charcoal.807d29df.svg";